module.exports = __webpack_public_path__ + "static/media/4.8e1fa68b.jpg";